<template>
  <div class="login">
    <div class="login-bg"></div>
    <div class="login-con">
      <!-- <iframe :src="wechatUrl" height="400px"></iframe> -->
      <Tabs value="name">
        <TabPane label="账号密码登录" name="name">
          <Form ref="formData1" :model="formData" :rules="ruleInline">
            <div style="height:168px">
              <FormItem prop="username">
                <Input type="text" size="large" v-model="formData.username" placeholder="请填写用户名或手机号">
                </Input>
              </FormItem>
              <FormItem prop="password">
                <Input type="password" size="large" v-model="formData.password" placeholder="请填写密码" @keyup.enter.native="handleSubmit('formData1')">
                </Input>
              </FormItem>
              <div class="flex-sb-c">
                <FormItem style="margin-bottom:0">
                  <Checkbox v-model="formData.check">自动登录</Checkbox>
                </FormItem>
                <div class="flex-sb-c fontcolor-blue">
                  <span class="pointer mar10" @click="$router.push({name:'forget'})">忘记密码</span>
                  <span class="pointer" @click="$router.push({name:'register'})">注册新账号</span>
                </div>
              </div>
            </div>
            <FormItem style="margin-bottom: 10px">
              <Button size="large" @click="handleSubmit('formData1')" type="primary" style="width: 100%;" :disabled="isDisable">登录
              </Button>
            </FormItem>
          </Form>
          <div class="mat20">
            <div class="fontcolor-grey" style="text-align:center">——————————— 其他登录 ———————————</div>
            <div class="flex-c-c mat10">
              <!-- <a :href="wechatUrl"><img class="pointer mar20" src="@images/wechat.png" /></a> -->
              <img class="pointer mar20" src="@images/wechat.png" @click="wechat" />
              <!-- <img class="pointer" src="@images/zhifubao.png" /> -->
            </div>
          </div>
        </TabPane>
        <!-- <TabPane label="手机快速登录" name="phone">
          <Form ref="formData2" :model="formData" :rules="ruleInline">
            <div style="height:168px">
              <FormItem prop="phone">
                <Input type="text" size="large" v-model="formData.phone" placeholder="请输入手机号">
                </Input>
              </FormItem>
              <FormItem prop="code">
                <Input type="text" size="large" v-model="formData.code" placeholder="请输入验证码" style="width:calc(100% - 160px)" @keyup.enter.native="handleSubmit('formData2')">
                </Input>
                <Button size="large" type="primary" ghost class="fr" @click="getCode" v-if="!codeDisable">获取验证码
                </Button>
                <Button size="large" class="fr" disabled v-else>还有&nbsp;{{count}}&nbsp;s可重发
                </Button>
              </FormItem>
            </div>
            <FormItem style="margin-bottom: 10px">
              <Button size="large" @click="handleSubmit('formData2')" type="primary" style="width: 100%;" :disabled="isDisable">登录
              </Button>
            </FormItem>
          </Form>
        </TabPane> -->
      </Tabs>
    </div>

  </div>
</template>

<script>
import { login, getCode, mobileLogin, weChatLogin, rootDomain } from "@/api/api";
import { Storage } from '@/utils/storage.js'
import { ngetRequest, splitParams } from "@/utils/utils";
import md5 from 'js-md5';

let Base64 = require('js-base64').Base64;
let storage = new Storage();
export default {
  name: "login",
  components: {},
  data() {
    return {
      formData: {
        username: "",
        password: "",
        phone: "",
        code: "",
        check: false
      },
      ruleInline: {
        username: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" }
          // { type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }
        ],
        phone: [{ required: true, message: "手机号不能为空", trigger: "blur" }],
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
      },
      count: 60,
      timer: null,
      wechatUrl: weChatLogin,
      codeDisable: false,
      isDisable: false
    };
  },
  created() {
    // let Base64 = require("js-base64").Base64;
    // let account = this.getCookie("account");
    // let password = this.getCookie("password");
    // this.formInline.user = account;
    // this.formInline.password = password;
  },
  methods: {
    //获取验证码
    getCode() {
      const TIME_COUNT = 60;
      if (this.formData.phone) {
        let params = {
          phoneNumber: this.formData.phone,
          sign: md5(('UksLsWUX8o3KHPdowTCZNcGq8eoxaMkH' + this.formData.phone).toUpperCase())
        }
        // console.log(params)
        getCode(params).then((res) => {
          console.log(res)
          if (res.code == 1) {
            this.$Message.success(res.message)
            this.codeDisable = !this.codeDisable;
            if (!this.timer) {
              this.count = TIME_COUNT;
              // this.show = false;
              let _this = this
              this.timer = setInterval(() => {
                if (_this.count > 0 && _this.count <= TIME_COUNT) {
                  _this.count--;
                } else {
                  clearInterval(_this.timer);
                  _this.timer = null;
                  _this.codeDisable = !_this.codeDisable;
                }
              }, 1000)
            }

          } else {
            this.$Message.error(res.message || '系统异常')
          }
        });
      } else {
        this.$Message.error('请先填写手机号');
      }

    },
    // 登陆
    handleSubmit(name) {
      let _this = this;
      _this.isDisable = true;
      _this.$refs[name].validate(valid => {
        if (valid) {
          //   // let Base64 = require("js-base64").Base64;
          let autoLog = this.formData.check ? "" : "86400000"
          let params, submit
          if (name == 'formData1') {
            params = {
              username: _this.formData.username,
              password: Base64.encode(_this.formData.password),
              loginType: 2
            };
            submit = login
          } else if (name == 'formData2') {
            params = {
              code: this.formData.code,
              phoneNumber: this.formData.phone
            };
            submit = mobileLogin
          }

          submit(params).then(res => {
            // console.log(res.data.userInfo)
            _this.isDisable = false;
            if (res.code == 1) {
              this.$Message.success("登录成功");


              this.$cookies.set("sso_token", res.data.access_token, '1d', "/", rootDomain);
              this.$cookies.set("sso_userId", res.data.userInfo.id, '1d', "/", rootDomain);
              this.$store.commit("setData", {
                key: "userId",
                val: JSON.stringify(res.data.userInfo.id)
              });

              // localStorage.setItem("user", JSON.stringify(res.data.userInfo));
              // localStorage.setItem("token", JSON.stringify(res.data.access_token));
              // http://192.168.1.61:8080/#/login?href=22222222222222222222
              // this.$store.commit("changeUserMess");
              // console.log(this.getRequest());
              let len = Object.keys(ngetRequest(location.hash)).length;

              if (!len) {
                this.$router.push({ name: "home" });
              } else {
                let link = ngetRequest(location.hash)
                let paramStr = splitParams(link) == "" ? '' : `?${splitParams(link)}`
                window.location.href = `${link.href}${paramStr}`
                // window.location.href = this.getRequest().href;
                // console.log(this.getRequest().href + "?token=" + this.$storage.getItem("token") + "&userid=" + this.$storage.getItem("user").id)
                // window.location.href = this.getRequest().href + "?token=" + this.$storage.getItem("token") + "&userid=" + this.$storage.getItem("user").id;
              }
            } else {
              this.$Message.error(res.message);
            }
          }).catch(function (error) {
            _this.isDisable = false;
          });
        } else {
          this.isDisable = false;
        }
      });
    },
    //微信登录
    wechat() {
      let link = ngetRequest(location.hash)
      let paramStr = splitParams(link) == "" ? '' : `?${splitParams(link)}`
      let href = `${link.href}${paramStr}` == 'undefined' ? '' : `${link.href}${paramStr}`
      // console.log(href)
      let encodeHref = encodeURIComponent(href)
      // console.log(encodeHref)
      // console.log(`${weChatLogin}?state=${encodeHref}`)
      window.location.href = `${weChatLogin}?state=${encodeHref}`
    },

    getCookie: function (key) {
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + "=");
        if (start !== -1) {
          start = start + key.length + 1;
          var end = document.cookie.indexOf(";", start);
          if (end === -1) end = document.cookie.length;
          return unescape(document.cookie.substring(start, end));
        }
      }
      return "";
    },
    setCookie: function (cName, value, expiredays) {
      var exdate = new Date();
      expiredays = 30;
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie =
        cName +
        "=" +
        decodeURIComponent(value) +
        (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
    }
  },
  mounted() { }
};
</script>

<style scoped lang="less">
@import "./info.less";

#nowDiv,
#link_more > a,
.divCurrentWeather {
  display: none;
}

.m-ct1 /deep/ .cityname {
  font-size: 22px !important;
}
</style>
